// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__9srsD","content":"LayoutSettings_content__2pq8k"};